import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { ImportExternalErpAddressFlow } from '@Components/Stammdaten';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { addressColumns } from '@Constants/TableColumns';
import { useListApi } from '@Hooks/useListApi';
import { EnumFrontendLayoutSetting } from '@Model';
import { AddressesRepository } from '@Repositories/Stammdaten';
import { Button, type ToolbarOptions } from '@synqo/frontend-component-library';
import { useHasPermission, useUsesExternalErp } from '@Contexts/appContext';
import { useMemo, useState } from 'react';

export function FrameListAddress() {
    const hasPermission = useHasPermission();
    const usesExternalErp = useUsesExternalErp();

    const module = useListApi(AddressesRepository, STAMMDATEN_API);

    const [isImportOpen, setIsImportOpen] = useState(false);
    const canImportFromExternalErp = usesExternalErp && hasPermission(Permission.StammdatenExternalErpImportFromErp);

    const toolbarElements = useMemo(
        () =>
            canImportFromExternalErp
                ? (standard: ToolbarOptions[]) => [
                      ...standard,
                      <Button key="import-erp-address" onClick={() => setIsImportOpen(true)} variant="secondary">
                          Adresse importieren
                      </Button>,
                  ]
                : undefined,
        [canImportFromExternalErp],
    );

    return (
        <>
            <TableWithStoredSettingsAndLayoutSettings
                layoutSettingsContext={EnumFrontendLayoutSetting.AddressesTableLayout}
                name={'AddressList'}
                columns={addressColumns}
                loader={module.loadPage}
                canCreate={hasPermission(Permission.StammdatenAddressesCreate)}
                useOnClickNavigation
                fullSize
                toolbarElements={toolbarElements}
            />
            <ImportExternalErpAddressFlow isOpen={isImportOpen} onClose={() => setIsImportOpen(false)} />
        </>
    );
}
